import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';

export interface IGetSmbVolumeDetailsParams {
    poolId: string;
    path: string;
}

export interface IGetSmbVolumeDetailsResult extends IResult {
    success?: {
        poolId: string;
        username: string;
        password: string;
    };
    error?: BaasEdgePoolError;
}

export class GetSmbVolumeDetailsRequest extends Request<IGetSmbVolumeDetailsParams, IGetSmbVolumeDetailsResult> {
  constructor(params: IGetSmbVolumeDetailsParams) {
    super('getSmbVolumeDetails', params);
  }
}
